export default "__VITE_ASSET__9d8b026a__"